// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon__16i6s","actions":"actions__2P6NO","dash":"dash__9O5uZ","status":"status__3YC32","active":"active__1O3Od","toggleText":"toggleText__2JoeC"};